var exports = {
  "k": "xcc377c0b--2d3f08--container",
  "n": "xcc377c0b--2d3f08--link",
};

module.exports = exports;
